<template>
  <b-autocomplete
    icon="magnify"
    v-model="q"
    :data="data"
    placeholder="Search user by Name, ID, Email"
    field="email"
    :loading="isFetching"
    @input="getAsyncData"
    @select="
      (option) => {
        selected = option;
      }
    "
    open-on-focus
    expanded
  >
    <template slot-scope="props">
      <div class="media is-middle">
        <div class="media-left"></div>

        <div class="media-content">
          <strong>{{ props.option.id }}</strong>
          <br />
          <span class="mr-2">{{ props.option.name }}</span>
          <span class="has-text-grey">&lt;{{ props.option.email }}&gt;</span>
        </div>
      </div>
    </template>
  </b-autocomplete>
</template>

<script>
import throttle from "lodash/throttle";

export default {
  props: {
    current: Object,

    onlyAdmin: {
      default: null,
    },
  },

  data() {
    return {
      data: [],
      q: "",
      selected: null,
      isFetching: false,
    };
  },

  created() {
    this.getAsyncData();

    if (this.current) {
      this.name = this.current.name;
    }
  },

  watch: {
    selected(user) {
      this.$emit("input", user ? user.id : null);

      this.$emit("change", user);
    },

    onlyAdmin() {
      this.getAsyncData();
    },
  },

  methods: {
    getAsyncData: throttle(function() {
      this.data = [];
      this.isFetching = true;
      this.$http
        .get("/admin/api/users", {
          params: {
            search: this.q,
            "filter[admin]": this.onlyAdmin ? !!this.onlyAdmin : null,
          },
        })
        .then(({ data }) => {
          data.data.forEach((item) => this.data.push(item));
          this.isFetching = false;
        })
        .catch((error) => {
          this.isFetching = false;
          throw error;
        });
    }, 300),
  },
};
</script>
